export default "__VITE_ASSET__CaTPngt$__"